import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { isInStock } from "../lib/stock";

export default function ProductCard({ product, index = 0 }) {
  const inStock = isInStock(product.slug);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: index * 0.05 }}
      data-testid={`product-card-${product.slug}`}
      className="group border border-gray-200 bg-white hover-lift"
    >
      <Link to={`/urunler/${product.slug}`} className="block">
        <div className="aspect-[4/3] bg-gray-50 overflow-hidden border-b border-gray-200 relative">
          <img
            src={product.image_url}
            alt={product.name}
            loading="lazy"
            width="640"
            height="480"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {inStock && (
            <span
              data-testid={`stock-badge-top-${product.slug}`}
              className="absolute top-3 right-3 inline-flex items-center gap-1.5 bg-white/95 backdrop-blur border border-emerald-200 text-emerald-700 px-2.5 py-1 text-[10px] uppercase tracking-[0.16em] font-semibold shadow-sm"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
              Stokta
            </span>
          )}
        </div>
        {/* Stok satırı — resmin hemen altı */}
        <div
          data-testid={`stock-indicator-${product.slug}`}
          className={`flex items-center gap-2 px-5 py-2.5 border-b ${
            inStock
              ? "bg-emerald-50/60 border-emerald-100"
              : "bg-gray-50 border-gray-100"
          }`}
        >
          <span
            className={`relative flex h-2.5 w-2.5 items-center justify-center`}
            aria-hidden
          >
            {inStock && (
              <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70 animate-ping" />
            )}
            <span
              className={`relative inline-block h-2.5 w-2.5 rounded-full ${
                inStock ? "bg-emerald-500" : "bg-red-500"
              }`}
              style={
                inStock
                  ? { boxShadow: "0 0 8px rgba(16,185,129,0.9)" }
                  : { boxShadow: "0 0 6px rgba(239,68,68,0.6)" }
              }
            />
          </span>
          <span
            className={`text-xs font-semibold uppercase tracking-[0.16em] ${
              inStock ? "text-emerald-700" : "text-red-600"
            }`}
          >
            {inStock ? "Stokta Var" : "Stokta Yok"}
          </span>
        </div>
        <div className="p-5">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[10px] uppercase tracking-[0.2em] font-mono-fd text-gray-400">
              {product.specs?.["Voltaj"] || ""}
            </span>
            <span className="text-[10px] uppercase tracking-[0.2em] font-mono-fd text-[#059669]">
              {product.specs?.["Pik Akım"] || ""}
            </span>
          </div>
          <h3 className="font-display text-lg leading-tight mb-2 tracking-tight">{product.name}</h3>
          <p className="text-sm text-gray-600 line-clamp-2">{product.short_description}</p>
          <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3">
            <span className="text-xs text-gray-500">Detayları İncele</span>
            <span className="text-[#059669] text-sm font-semibold">→</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
